module.exports = __webpack_public_path__ + "img/6.3a68dc7.jpg";